goog.module('yext.plugins.contextualHelp');
goog.module.declareLegacyNamespace();

(function($, undefined) {
  var defaultOptions = {
    customClass: null,
    bindToElement: true, // always position to element
    width: 200, // The styleguide recommends a max width of 200px
    maxWidth: '', // Clients can also specify the 'maxWidth'
    event: 'click', // What event to trigger the tooltip on
    fade: false, // Whether or not to fade the tooltip in
    fadeDuration: 500, // How long the fade-in animation should last
    hoverDelay: 0, // Time to wait before showing tooltip after event
    interactive: false, // Should users be able to interact with the tooltip?
    location: 'bottom', // Tooltip's location relative to trigger element,
    allowHTML: true, // If false, use $.fn.text() for options['help'] and options['basicText']
    disable: false, // Disables the contextual help pop up
    condition: function() {
      return true;
    }, // Return false to not show the tooltip based upon some condition
    onTrigger: function() { }, // Function used to render elements on trigger that would otherwise only exist in VDOM
  };

  var namespace = 'contextualHelp';
  var className = 'contextual-help';
  var interactiveTimeout;
  var activeNode;

  /**
   * TODO(mattjs) <div> added to help arrow b/c of incompatibility with 'native'
   * arrow, this could be thought through better or fixed when old tooltip style
   * is removed
   */
  var $contextualHelpArrow = $('<div>').addClass(className + '-arrow').append('<div>');
  var $contextualHelpContent = $('<div>').addClass(className + '-content');
  var $contextualHelpElement = $('<div>');

  $contextualHelpElement
    .addClass(className + '-container')
    .append($contextualHelpContent)
    .append($contextualHelpArrow)
    .hide();

  $('body').append($contextualHelpElement);

  /**
   * Positions the tool tip based upon the target
   * @param {!jQuery} target Element or click which to position the tooltip
   * @param {string} location - the position of the contextual help
   */
  // TODO(kyu): consider having options to define offset instead of these defaults
  var positionToolTip = function(target, location) {
    var atPos = 'center bottom';
    var myPosContainer = 'center top+10';
    var myPosArrow = 'center top+6';

    if (location === 'top') {
      atPos = 'center top';
      myPosContainer = 'center bottom-10';
      myPosArrow = 'center bottom-2';
    } else if (location === 'right') {
      atPos = 'right center';
      myPosContainer = 'left+8 center';
      myPosArrow = 'left+5 center';
    } else if (location === 'left') {
      atPos = 'left center';
      myPosContainer = 'right-9 right';
      myPosArrow = 'right+3 right';
    }

    $contextualHelpElement.position({
      'my': myPosContainer,
      'at': atPos,
      'of': target,
      'collision': 'fit none',
    });

    $contextualHelpArrow.position({
      'my': myPosArrow,
      'at': atPos,
      'of': target,
      'collision': 'none',
    });
  };

  /**
   * Resets the tooltip to a basic state after having data bound
   */
  var resetHelpElement = function() {
    $contextualHelpElement.prop('class', className + '-container');
    $contextualHelpContent.empty();
    $contextualHelpElement.css({top: 0, left: 0, width: ''});
    $contextualHelpArrow.css({top: 0, left: 0});
    $contextualHelpArrow.removeClass('top bottom left right');
  };

  /**
   * Update tooltip data, this will style the tooltip and add content
   * @param {!Object} options Content and styling for the tooltip
   * @param {!jQuery} $target The target element for the tooltip
   */
  var updateData = function(options, $target) {
    $contextualHelpElement
      .addClass(options.customClass)
      .css('width', options['width'])
      .css('max-width', options['maxWidth']);

    // Ways to fill the content of the tooltip
    if (options['help']) {
      if (options['allowHTML']) {
        $contextualHelpContent.html(window.contextualHelp[options['help']]);
      } else {
        $contextualHelpContent.text(window.contextualHelp[options['help']]);
      }
    } else if (options['basicText']) {
      if (options['allowHTML']) {
        $contextualHelpContent.html(options['basicText']);
      } else {
        $contextualHelpContent.text(options['basicText']);
      }
    } else if (options['contentElement']) {
      if (options['elementContext']) {
        var $content = $target.closest(options['elementContext'])
          .find(options['contentElement'])
          .clone(true)
          .show();
        $contextualHelpContent.html($content);
      } else {
        $contextualHelpContent.html($(options['contentElement']).clone(true).show());
      }
    }
  };

  /**
   * Binds mouseenter and mouseleave events to the tooltip so the delayed
   * hide will be cleared when a user interacts with the tooltip and then
   * a new delayed hide will be created when they mouse out
   */
  var bindInteractive = function() {
    $contextualHelpElement.off('mouseenter.'+namespace);
    $contextualHelpElement.off('mouseleave.'+namespace);

    $contextualHelpElement.on('mouseenter.'+namespace, function() {
      clearTimeout(interactiveTimeout);
    });

    $contextualHelpElement.on('mouseleave.'+namespace, function() {
      interactiveDelayedHide();
    });
  };

  /**
   * Hides the tooltip after a short window giving the user time to interact
   * with it before it closes
   */
  var interactiveDelayedHide = function() {
    clearTimeout(interactiveTimeout);

    interactiveTimeout = setTimeout(function() {
      $contextualHelpElement.off('mouseenter.'+namespace);
      $contextualHelpElement.off('mouseleave.'+namespace);
      hideTip();
    }, 200);
  };

  /**
   * Show the tooltip with the option to have it fade in
   * @param {boolean} fade Animation effect, true will use fadeIn, false show
   * @param {number} fadeDuration length of the fade, in ms
   */
  var showTip = function(fade, fadeDuration) {
    clearTimeout(interactiveTimeout);

    if (fade) {
      $contextualHelpElement.fadeIn(fadeDuration);
    } else {
      $contextualHelpElement.show();
    }
  };

  /**
   * Hide the tooltip
   */
  var hideTip = function() {
    $contextualHelpElement.hide();
  };
  // TODO(mattjs) Figure out a better way to export this
  goog.exportSymbol('hideContextualHelp', hideTip);

  /**
   * Get the event name including namespacing, used to return both mouseenter and
   * mouseleave when hover is provided
   *
   * @param {string} event Event name (hover or click)
   */
  var getEvent = function(event) {
    if (event == 'hover') {
      return 'mouseenter.' + namespace + ' mouseleave.' + namespace;
    }

    return event + '.' + namespace;
  };

  /**
   * Binds general events which include a 'click off' and that will fire when
   * clicking on anything that is not the tooltip
   * @suppress {deprecated}
   */
  var bindGeneralEvents = function() {
    $(document).off('click.'+ namespace + ' keydown.' + namespace);
    $contextualHelpElement.off('click.'+ namespace);
    $(window).off('resize.'+namespace);

    // Bind a general closer for the tooltip
    $(document).on('click.'+ namespace + ' keydown.' + namespace, function(e) {
      if (e.type == 'click'
          || (e.type == 'keydown' && e.keyCode == $.ui.keyCode.ESCAPE)) {
        hideTip();
      }
    });

    // Keep clicks on the tooltip from bubbling
    $contextualHelpElement.on('click.'+ namespace, function(e) {
      e.stopPropagation();
    });

    $(window).on('resize.'+namespace, function() {
      hideTip();
    });
  };

  /**
   * Contextual Help jQuery 'Constructor'
   *
   * Binds the interaction event to the tooltip as well as configuring the
   * default options
   * @param {!Object=} _options
   */
  $.fn.contextualHelp = function(_options) {
    bindGeneralEvents();

    return this.each(function() {
      var $this = $(this);
      var delayTimeout;
      var options = $.extend(true, {}, defaultOptions, _options, $this.data());

      if ($this.hasClass('no-contextual-help')) {
        return;
      }

      $this.off('.'+namespace);
      if (options.disable) {
        return;
      }

      $this.on(getEvent(options.event), function(e) {
        !options.propagate && e.stopPropagation(); // Keep this from bubbling

        // Conditionally do not show tooltip
        if (!options.condition.call(this)) {
          return;
        }

        var visible = $contextualHelpElement.is(':visible');

        resetHelpElement();
        updateData(options, $this);
        $contextualHelpElement.show(); // Show briefly for correct positioning
        options.onTrigger();

        if (options.bindToElement) {
          positionToolTip($this, options['location']);
        } else {
          positionToolTip(e, options['location']);
        }

        $contextualHelpArrow.addClass(options['location']);

        if (!visible) {
          $contextualHelpElement.hide();
        }

        if (options.event == 'click') {
          // If the element clicked on prior to the current click is the same
          // and the tooltip is currently visible, hide it because the click
          // event should toggle visibility
          if (visible && activeNode == this) {
            hideTip();
          } else {
            showTip(options.fade, options.fadeDuration);
          }
        } else if (options.event == 'hover') {
          if (e.type == 'mouseenter') {
            if (options.interactive) {
              bindInteractive();
            }

            delayTimeout = setTimeout(function() {
              // Only show the help tip if the anchor element is visible
              if ($this.is(':visible')) {
                showTip(options.fade, options.fadeDuration);
              }
            }, options.hoverDelay);
          } else if (e.type == 'mouseleave') {
            clearTimeout(delayTimeout);

            if (options.interactive) {
              interactiveDelayedHide();
            } else {
              hideTip();
            }
          }
        }
        activeNode = this;
      });
    });
  };
})(jQuery);

